import { SkeletonBox } from '@circlefin/components'
import { createFormInput } from '@circlefin/form/Form.Input'
import { useStates } from '@features/locales/hooks/states'
import useTranslation from 'next-translate/useTranslation'

import { L3OnboardingDropdown } from '../../L3OnboardingDropdown'

import type { L3OnboardingDropdownVariantProps } from '../types'
import type { CountryCode } from '@shared/graphql'

export interface BusinessStateOfRegistrationProps
  extends L3OnboardingDropdownVariantProps {
  /**
   * Selected country.
   */
  country: CountryCode
}

const Input = createFormInput()

export const BusinessStateOfRegistration: React.FC<
  BusinessStateOfRegistrationProps
> = ({ country, disabled, warning, name }) => {
  const { t } = useTranslation('l3Onboarding')
  const states = useStates({
    country,
    link: { locatedIn: true },
  })

  if (states.loading) {
    return <SkeletonBox className="mt-6 h-10 w-full" />
  }

  if (states.data?.states && states.data.states.codes.length > 0) {
    return (
      <L3OnboardingDropdown
        disabled={disabled}
        items={states.states.toDropdown()}
        label={t(
          `forms.businessRegistrationDetails.businessStateOfRegistrationOfFormation.${country}.label`,
        )}
        name={name}
        warning={warning}
      />
    )
  }

  return (
    <Input
      className="w-full"
      disabled={disabled}
      label={t`forms.businessRegistrationDetails.businessStateOfRegistrationOfFormation.other.label`}
      name={name}
      warning={warning}
    />
  )
}
